import React, {useEffect} from 'react';
import {
  ActionModal,
  FormInput,
  useErrorHandler,
  ErrorModal,
  formatInputNumber,
  parseFormattedNumber,
} from '../../../../shared';
import {useDepositFundsForm} from '../../model';
import {DepositFundsConfirmModal} from '../DepositFundsConfirmModal';

interface DepositFundsModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const DepositFundsModal = ({open, setOpen}: DepositFundsModalProps) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    isLoading,
    submitError,
    resetForm,
    submitForm,
    showConfirmModal,
    setShowConfirmModal,
    formDataForConfirm,
    handleConfirmDeposit,
  } = useDepositFundsForm({setOpen});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Внесение средств',
    title: 'Ошибка при внесении средств',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  // Очистка формы при открытии модального окна
  useEffect(() => {
    if (open) {
      resetForm();
    }
  }, [open, resetForm]);

  // Специальный обработчик для поля суммы с форматированием
  const handleAmountChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const inputValue = event.target.value;

    if (!/^[\d\s.]*$/.test(inputValue)) {
      return;
    }

    const numericValue = parseFormattedNumber(inputValue);

    setFieldValue('amount', numericValue.toString());
    setFieldTouched('amount', true);
  };

  // Получаем отформатированное значение суммы для отображения
  const getFormattedAmount = () => {
    const amount = values.amount;
    return amount !== '' ? formatInputNumber(amount) : '';
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Внести средства'}
        textButtonApply={'Готово'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Сумма"
          placeholder="Введите сумму"
          name="amount"
          type="text"
          value={getFormattedAmount()}
          onChange={handleAmountChange}
          onBlur={handleBlur}
          error={touched.amount && errors.amount}
          isRequired
        />

        <FormInput
          label="Комментарий для бухгалетра"
          placeholder="Комментарий"
          name="reason"
          value={values.reason}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.reason && errors.reason}
          isTextarea
        />
      </ActionModal>

      <DepositFundsConfirmModal
        open={showConfirmModal}
        setOpen={setShowConfirmModal}
        formData={formDataForConfirm}
        onConfirm={handleConfirmDeposit}
        isLoading={isLoading}
      />

      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
